module.exports = __webpack_public_path__ + "img/graycrosspin.b8ce6cca.svg";